import { MESSAGE_TYPES } from '../types/messages';
import type { ChatMessage } from '../types/messages';

export const AI_MODE_LABELS = {
  SEARCH_TRIP: 'AI予約モード',
  SEARCH_SUPPORT: '情報検索モード'
} as const;

export const getCurrentAiModeLabel = (messages: ChatMessage[]): string => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message.direction !== 'ai') {
      continue;
    }
    if (
      message.type === MESSAGE_TYPES.OPTIMISTIC ||
      message.type === MESSAGE_TYPES.ERROR ||
      message.type === MESSAGE_TYPES.SYSTEM
    ) {
      continue;
    }
    if (message.type === MESSAGE_TYPES.SEARCH_SUPPORT_INSIGHT) {
      return AI_MODE_LABELS.SEARCH_SUPPORT;
    }
    return AI_MODE_LABELS.SEARCH_TRIP;
  }

  return AI_MODE_LABELS.SEARCH_TRIP;
};
